import { BaseService } from "../BaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { TherapistStatusHistoryModel } from "../../models/api/TherapistStatusHistoryModel";
import { TherapistStatusHistoryFindResultModel } from "../../models/api/TherapistStatusHistoryFindResultModel";

export abstract class TherapistStatusHistoryBaseService extends BaseService {

    private urlPart: string = 'TherapistStatusHistory';

    constructor(private http: HttpClient, private router: Router, private auth: AuthService) {
        super(http, router, auth);
        this.apiSegmentUrl = this.urlPart;
    };

    /// <summary>
    /// FIND: Retrieves a list of TherapistStatusHistory records from the database
    /// /TherapistStatusHistory
    /// </summary>
    public findTherapistStatusHistory(page: number = 0, size: number = 0, orderBy: string = "", orderDirection: string = "ASC", filter: string = "", therapistid: number = 0, therapiststatusid: number = 0): Observable<TherapistStatusHistoryFindResultModel>
    {
        // Find TherapistStatusHistory Records

        const url = `${super.getBaseUrl()}?page=${page}&size=${size}&orderBy=${orderBy}&orderDirection=${orderDirection}&filter=${filter}&therapistid=${therapistid}&therapiststatusid=${therapiststatusid}`;

        if (!environment.production)
            console.log("Find TherapistStatusHistory: Calling " + url);

        return this.http.get<TherapistStatusHistoryFindResultModel>(url)
            .pipe(
                map(next => {
                    let o: TherapistStatusHistoryFindResultModel = Object.assign(new TherapistStatusHistoryFindResultModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    /// <summary>
    /// GET: Retrieves a single TherapistStatusHistory record from the database
    /// /TherapistStatusHistory/{therapiststatushistoryid}
    /// </summary>
    /// <param name="therapiststatushistoryid"></param>
    /// <returns></returns>
    public getTherapistStatusHistory(therapiststatushistoryid: number): Observable<TherapistStatusHistoryModel>
    {

        // Get Single TherapistStatusHistory Record

        // TODO: Get Single TherapistStatusHistory Record

        const url = `${super.getBaseUrl()}/${therapiststatushistoryid}`;

        if (!environment.production)
            console.log("Get TherapistStatusHistory: Calling " + url);

        return this.http.get<TherapistStatusHistoryModel>(url)
            .pipe(
                map(next => {
                    let o: TherapistStatusHistoryModel = Object.assign(new TherapistStatusHistoryModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    /// <summary>
    /// POST: Adds a new TherapistStatusHistory record to the database
    /// /TherapistStatusHistory/{therapiststatushistoryid}
    /// </summary>
    /// <param name="therapiststatushistoryid"></param>
    /// <returns></returns>
    public createTherapistStatusHistory(newRecord: TherapistStatusHistoryModel): Observable<TherapistStatusHistoryModel>
    {
        // Add Single TherapistStatusHistory Record

        const url = `${super.getBaseUrl()}`;

        if (!environment.production)
            console.log("Create TherapistStatusHistory:Calling " + url);

console.log(JSON.stringify(newRecord));

        return this.http.post<TherapistStatusHistoryModel>(url, newRecord)
            .pipe(
                map(next => {
                    let o: TherapistStatusHistoryModel = Object.assign(new TherapistStatusHistoryModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    /// <summary>
    /// PUT: Updates an existing TherapistStatusHistory record in the database
    /// /TherapistStatusHistory/{therapiststatushistoryid}
    /// </summary>
    /// <param name="therapiststatushistoryid"></param>
    /// <returns></returns>
    public updateTherapistStatusHistory(therapiststatushistoryid: number, updatedRecord: TherapistStatusHistoryModel): Observable<TherapistStatusHistoryModel>
    {
        // Update Single TherapistStatusHistory Record

        const url = `${super.getBaseUrl()}/${therapiststatushistoryid}`;

        if (!environment.production)
            console.log("Update TherapistStatusHistory: Calling " + url);

        return this.http.put<TherapistStatusHistoryModel>(url, updatedRecord)
            .pipe(
                map(next => {
                    let o: TherapistStatusHistoryModel = Object.assign(new TherapistStatusHistoryModel(), next);
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    public updateTherapistStatusHistoryRecord(updatedRecord: TherapistStatusHistoryModel): Observable<TherapistStatusHistoryModel>
    {
        return this.updateTherapistStatusHistory(updatedRecord.therapistStatusHistoryID, updatedRecord);
    }

    /// <summary>
    /// DELETE: Deletes an existing TherapistStatusHistory record from the database
    /// /TherapistStatusHistory/{therapiststatushistoryid}
    /// </summary>
    /// <param name="therapiststatushistoryid"></param>
    /// <returns></returns>
    public deleteTherapistStatusHistory(therapiststatushistoryid: number): Observable<ApiResult>
    {
        // Delete Single TherapistStatusHistory Record

        const url = `${super.getBaseUrl()}/${therapiststatushistoryid}`;

        if (!environment.production)
            console.log("Delete TherapistStatusHistory: Calling " + url);

        return this.http.delete<ApiResult>(url)
            .pipe(
                map(next => {
                    let o: ApiResult = new ApiResult();
                    o.success = true;
                    return o;
                }),
                retryWhen(errors =>
                    errors.pipe(
                        concatMap((error, count) => {
                            if (count > this.RETRY_CEILING) return throwError(error);
                            return this.tokenCheckAndRefresh(error);
                        }),
                        delay(1000),
                    ),
                ),
                catchError(this.errorHandler)
            );
    }

    public deleteTherapistStatusHistoryRecord(deleteRecord: TherapistStatusHistoryModel): Observable<ApiResult>
    {
        // Delete Single TherapistStatusHistory Record
        return this.deleteTherapistStatusHistory(deleteRecord.therapistStatusHistoryID);
    }

}
